import { Link } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import * as React from "react"
import { useState } from "react"
import { Link as RouteLink, Redirect } from "react-router-dom"
import { RoutePaths } from "../../../../portal-app/src/routing/RoutePaths"
import { CCUtils } from "../../common/CCUtils"
import { log } from "../../common/Logging"
import { ClassStoreSA } from "../classes/ClassStoreSA"
import { FormWrapper } from "../generic-components/FormWrapper"
import { useForm } from "../hooks/useForm"
import { appTheme } from "../StyleUtils"
import { LoginRoutes } from "../WebApp"
import { LoginPage } from "./LoginPage"
import { StudentAccountStore } from "./StudentAccountStore"

export const StudentJoinClass = () => {
    const [validClassCode, setValid] = useState<boolean>(false)
    const [error, setError] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)

    const joinClass = async () => {
        setLoading(true)
        const clazz = await ClassStoreSA.instance.findClassByCode(
            inputs.classCode,
        )
        log.debug(`Found class for class code: ${clazz}`)
        if (clazz == null) {
            setError(true)
            setLoading(false)
        } else {
            setError(false)
            StudentAccountStore.instance.classCode = inputs.classCode
            StudentAccountStore.instance.classId = clazz.id
            StudentAccountStore.instance.classGrade = clazz.classGrade

            const teacher =
                await StudentAccountStore.instance.findTeacherByTeacherId(
                    clazz.teacherId,
                )
            log.debug("Found teacher for class by id: " + teacher)
            StudentAccountStore.instance.teacherName = teacher.preferredTitle
            setValid(true)
        }
    }

    const initialValue = { classCode: StudentAccountStore.instance.classCode }

    const { inputs, handleInputChange } = useForm(initialValue)

    const audioFile = CCUtils.asset("auth/register/enter-class-code.mp3")

    if (validClassCode) {
        return <Redirect to={LoginRoutes.createStudentAccount} push={true} />
    }

    return (
        <LoginPage title={"Join Class"} squeeze={true}>
            <audio src={audioFile} autoPlay />
            <Typography
                variant={"body2"}
                style={{ marginBottom: appTheme.spacing(4) }}
            >
                Enter your class code to join Click City. If you don’t know your
                class code, talk to your teacher.
            </Typography>
            <FormWrapper
                onClick={joinClass}
                buttonLabel={"Continue"}
                disabled={loading || validClassCode}
                loading={loading}
                firstForm={true}
            >
                <TextField
                    label={"Class Code"}
                    fullWidth={true}
                    autoFocus={true}
                    error={error}
                    name={"classCode"}
                    value={inputs.classCode}
                    onChange={handleInputChange}
                    helperText={error ? "That code does not exist" : ""}
                    inputProps={{
                        autoCapitalize: "none",
                    }}
                />
            </FormWrapper>
            <Typography
                variant={"body2"}
                style={{
                    marginTop: appTheme.spacing(3),
                    width: "100%",
                    textAlign: "center",
                }}
            >
                Already have an account?{" "}
                <Link component={RouteLink} to={RoutePaths.home}>
                    Login
                </Link>
            </Typography>
        </LoginPage>
    )
}
